import React from 'react'
import CardInfo from '../../../../../components/CardInfo/CardInfo'
import useScreen from '../../../../../hooks/useScreen'
import FleetTable from '../../../../FleetPage/components/FleetTable'
import RequestTable from '../../../../RequestsPage/RequestTable'
import CreateRepairRequestForm from './CreateRepairRequestForm'
import PropTypes from 'prop-types'

export const RenderContent = ({
    steps,
    selectedAsset,
    setSelectedAsset,
    filteredOpenRequests,
    onFilterOpenRequests,
    onCheckAftersHours,
    formRef,
    setError,
    setIsValidForm,
    isEstimate,
    successfulSubmit,
    setSuccessfulSubmit,
    resetTouch,
    setResetTouch,
    images,
    photosIds,
    setImages,
    setPhotosIds,
}) => {
    const { isMobile, isTablet } = useScreen()
    const renderSelectAssetContent = () => {
        const isMobileOrTablet = isMobile || isTablet
        const title = 'Asset for Repair'
        const subtitle =
            'Select the asset for which you would like to submit a request'

        const fleetTableProps = {
            onSelectItems: setSelectedAsset,
            selectedItems: selectedAsset,
            selectable: true,
            isInCard: true,
            isCreateRequest: true,
            fetchOnceKey: 'create-repair-request-asset-list',
        }

        return isMobileOrTablet ? (
            <FleetTable
                {...fleetTableProps}
                title={title}
                subtitle={subtitle}
            />
        ) : (
            <CardInfo
                isTableContent
                hasRounded={true}
                title={title}
                subTitle={subtitle}
                content={<FleetTable {...fleetTableProps} />}
            />
        )
    }

    const renderCheckDuplicates = () => {
        const isMobileOrTablet = isMobile || isTablet
        const title = 'Check Duplicate Requests'
        const subtitle =
            'Make sure there are no similar requests opened for this asset'

        const requestTableProps = {
            getAllRequests: false,
            data: filteredOpenRequests,
            onFilter: onFilterOpenRequests,
            isInCard: true,
            isCreateRequest: true,
        }

        return isMobileOrTablet ? (
            <RequestTable
                {...requestTableProps}
                title={title}
                subtitle={subtitle}
            />
        ) : (
            <CardInfo
                isTableContent
                hasRounded={true}
                title={title}
                subTitle={subtitle}
                content={<RequestTable {...requestTableProps} />}
            />
        )
    }

    const activeStep = steps?.find(f => f.active === true)
    if (activeStep) {
        const stepName = activeStep.name
        switch (stepName) {
            case 'Select Asset':
                return renderSelectAssetContent()
            case 'Check Duplicates':
                return renderCheckDuplicates()
            case 'Request Details':
                return (
                    <CreateRepairRequestForm
                        onSubmitForm={onCheckAftersHours}
                        formRef={formRef}
                        asset={selectedAsset[0]}
                        setError={setError}
                        setValidForm={setIsValidForm}
                        isEstimate={isEstimate}
                        successfulSubmit={successfulSubmit}
                        setSuccessfulSubmit={setSuccessfulSubmit}
                        resetTouch={resetTouch}
                        setResetTouch={setResetTouch}
                        images={images}
                        photosIds={photosIds}
                        setImages={setImages}
                        setPhotosIds={setPhotosIds}
                    />
                )
            default:
                return null
        }
    }

    return null
}

RenderContent.propTypes = {
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            active: PropTypes.bool.isRequired,
            name: PropTypes.string.isRequired,
        }),
    ).isRequired,
    selectedAsset: PropTypes.array.isRequired,
    setSelectedAsset: PropTypes.func.isRequired,
    filteredOpenRequests: PropTypes.array.isRequired,
    onFilterOpenRequests: PropTypes.func.isRequired,
    onCheckAftersHours: PropTypes.func.isRequired,
    formRef: PropTypes.object.isRequired,
    setError: PropTypes.func.isRequired,
    setIsValidForm: PropTypes.func.isRequired,
    isEstimate: PropTypes.bool.isRequired,
    successfulSubmit: PropTypes.bool.isRequired,
    setSuccessfulSubmit: PropTypes.func.isRequired,
    resetTouch: PropTypes.bool.isRequired,
    setResetTouch: PropTypes.func.isRequired,
    images: PropTypes.array.isRequired,
    photosIds: PropTypes.array.isRequired,
    setImages: PropTypes.func.isRequired,
    setPhotosIds: PropTypes.func.isRequired,
}
